/* eslint-disable angular/window-service */
// jQuery
window.$ = window.jQuery = require('jquery/dist/jquery');

// Bootstrap
require('bootstrap/dist/js/bootstrap');
require('bootstrap/js/affix');
require('bootstrap-colorpicker/dist/js/bootstrap-colorpicker');

// Plugin JS
require('lodash/index');
window.moment = require('moment');
require('moment-timezone/builds/moment-timezone-with-data');
window.UaParser = require('ua-parser-js');

// D3
require('d3/d3');

// nvd3
window.nv = require('nvd3/build/nv.d3.js');

// TODO: disabled for now in viz
// require('jstat')
// require('zc_statistics')

// TODO: These do not work with webpack
//require('pickadate/lib/picker')
//require('pickadate/lib/picker.date')
//require('pickadate/lib/picker.time')

//= AngularJS
require('angular/angular');
require('angular-translate/dist/angular-translate');
require('angular-translate-loader-static-files/angular-translate-loader-static-files');
require('angular-animate/angular-animate');
require('angular-messages/angular-messages');
require('angular-resource/angular-resource');
require('angular-cookies/angular-cookies');
require('angular-local-storage/dist/angular-local-storage');
require('angular-ui-router/release/angular-ui-router');
require('angular-sanitize/angular-sanitize');
require('angular-ui-bootstrap/dist/ui-bootstrap-tpls');
require('ng-csv/build/ng-csv');
window.Flow = require('ng-flow/dist/ng-flow-standalone');

// Angular colorpicker
require('angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.js');

// Markdown
require('marked/marked.min.js');
require('angular-marked/lib/angular-marked.js');

require('angular-loading-bar/build/loading-bar.js');
require('highlight.js/lib/index.js');
require('angular-highlightjs/angular-highlightjs.js');
require('angular-md5/angular-md5');

// CSS files
require('bootstrap/dist/css/bootstrap.css');
require('angular-loading-bar/build/loading-bar.css');
require('alertify/themes/alertify.core.css');
require('alertify/themes/alertify.default.css');
require('pickadate/lib/compressed/themes/classic.css');
require('pickadate/lib/compressed/themes/classic.date.css');
require('pickadate/lib/compressed/themes/classic.time.css');
require('select2/select2.css');
require('font-awesome/css/font-awesome.css');
require('angular-bootstrap-colorpicker/css/colorpicker.min.css');
require('nvd3/build/nv.d3.css');
require('highlight.js/styles/tomorrow.css');

window.sift = require('sift/sift');
window.gql = require('graphql-tag');

window.ZC_CONFIG = require('env');



// WEBPACK FOOTER //
// ./src/external.js